module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bigpage"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-top": "2vh"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "10px",
      "display": "none"
    }
  }, [_c('mu-switch', {
    staticClass: "demo-switch",
    attrs: {
      "label": "绑定已有账号"
    },
    on: {
      "change": _vm.switchChange
    }
  })], 1), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入手机号",
      "type": "text",
      "icon": "smartphone",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserPhone),
      callback: function($$v) {
        _vm.UserPhone = $$v
      },
      expression: "UserPhone"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    style: ({
      display: _vm.userRegister
    }),
    attrs: {
      "hintText": "请输入密码",
      "type": "password",
      "icon": "lock",
      "fullWidth": ""
    },
    model: {
      value: (_vm.bindPwd),
      callback: function($$v) {
        _vm.bindPwd = $$v
      },
      expression: "bindPwd"
    }
  }), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%"
    },
    attrs: {
      "hintText": "请输入附加码",
      "type": "text",
      "icon": "vpn_key"
    },
    model: {
      value: (_vm.FJM1),
      callback: function($$v) {
        _vm.FJM1 = $$v
      },
      expression: "FJM1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "30%",
      "float": "right",
      "margin-top": "-0.1rem"
    },
    attrs: {
      "src": _vm.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%",
      "z-index": "1"
    },
    attrs: {
      "hintText": "请输入手机验证码",
      "type": "text",
      "icon": "verified_user"
    },
    model: {
      value: (_vm.YZM),
      callback: function($$v) {
        _vm.YZM = $$v
      },
      expression: "YZM"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }],
    on: {
      "click": _vm.getYZM
    }
  }, [_c('input', {
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#27ba69",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "value": "获取"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WaitTime),
      expression: "WaitTime"
    }],
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#eeeeee",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "#999"
    },
    attrs: {
      "type": "button"
    },
    domProps: {
      "value": (_vm.WaitTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.WaitTime = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.32rem",
      "margin-top": "0.2rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "马上绑定",
      "primary": ""
    },
    on: {
      "click": _vm.QuickLogin
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.3rem"
    },
    style: ({
      display: _vm.userRegister
    })
  }, [_c('a', {
    staticStyle: {
      "color": "#999999"
    },
    on: {
      "click": _vm.forgetPwd
    }
  }, [_vm._v("忘记密码？")])])], 1)]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../static/user/wxBind.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7519c13c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/checkWXBindResult.vue
// module id = 1545
// module chunks = 18